import { Component, h } from 'preact'
import { SketchPicker } from 'react-color'
import GlobalClick from '../interactive/documentClick'

interface Props {
  title: string,
  meta: string,
  selectedColor: string,
  className: string,
  onCallback: (color: string) => void
}

interface State {
  enablePicker: boolean
}

class ColorSelector extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      enablePicker: false
    }
  }

  render ({ title, meta, selectedColor, className, onCallback }: Props, { enablePicker }: State) {
    return (
      <GlobalClick onGlobalClick={() => {
        this.setState({ enablePicker: false })
      }} class={className}>
        <div
          onClick={() => this.setState({ enablePicker: true })}>
          <label>{title}</label>
          <div>{meta}</div>
          <div className='form-group form-control'>
            <span className='default-header_colors-visual'>
              <span style={{ backgroundColor: selectedColor }} className='default-header_colors-preview' />
              <span>{ selectedColor }</span>
            </span>
            <span className='default-header_colors-arrow-icon'>
              <i className='icon-full-arrow-bottom' />
            </span>
            <span className='default-header_colors-picker-container' >
              {
                enablePicker ? (
                  <SketchPicker
                    disableAlpha
                    color={selectedColor}
                    onChangeComplete={({ hex }: { hex: string }) => onCallback(hex)}
                  />
                ) : null
              }
            </span>
          </div>
        </div>
      </GlobalClick>
    )
  }
}

export default ColorSelector
